import React from 'react';
import { Faq } from '../../Models';
import { LinkList } from '../LinkList/LinkList';
import { LinkListElement } from '../LinkList/LinkListElement/LinkListElement';

export interface FaqListProps {
  className?: string;
  faqs: Faq[];
}

export const FaqList = ({
  className = '',
  faqs
}: FaqListProps): React.ReactElement<FaqListProps> => {
  return (
    <LinkList className={className}>
      {faqs.map((faq: Faq) => (
        <LinkListElement
          key={faq.id}
          to={`/faq/${faq.id}`}
          label={faq.question}
        />
      ))}
    </LinkList>
  );
};
